import React from "react";
import { LuCreditCard } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui";
import type { ButtonVariant } from "../../../components/ui";
import { useSession } from "../../../context/SessionContext";
import { useAccess } from "../../../hooks/useAccess";
import { useBillingPortal } from "../../../hooks/useBillingPortal";
import { precisaEscolherPlano } from "../../../lib/checkoutIntent";
import { WHATSAPP_PLANO_CLINICA } from "../../../constants/billing";
import { t } from "../../../i18n";
import { PATHS } from "../../../app/paths";

/** Botão de cobrança: portal do Stripe, escolher plano ou falar com a LetsDoc (clínica sem plano). */
export const BillingPortalButton: React.FC<{ variant?: ButtonVariant }> = ({ variant = "primary" }) => {
  const navigate = useNavigate();
  const { billing } = useSession();
  const { isAdmin, canViewBilling, canManagePlan, isCourtesy } = useAccess();
  const { goToPortal, loading } = useBillingPortal();
  const choosePlan = precisaEscolherPlano(billing);
  // Clínica sem plano não assina self-serve: negocia com a LetsDoc.
  const talkToLetsDoc = choosePlan && billing?.modo === "clinica";

  if (isAdmin || isCourtesy || !canViewBilling) return null;

  const onClick = () => {
    if (talkToLetsDoc) {
      window.open(WHATSAPP_PLANO_CLINICA, "_blank", "noopener,noreferrer");
      return;
    }
    if (choosePlan) {
      navigate(PATHS.plans);
      return;
    }
    goToPortal();
  };

  const label = talkToLetsDoc
    ? t("settings.portal.talkToLetsDoc")
    : choosePlan
      ? t("settings.portal.choosePlan")
      : loading
        ? t("settings.portal.opening")
        : canManagePlan
          ? t("settings.portal.cardAndInvoices")
          : t("settings.portal.updateCard");

  return (
    <Button
      variant={variant}
      size="sm"
      className={variant === "primary" ? "self-start" : undefined}
      icon={<LuCreditCard aria-hidden />}
      onClick={onClick}
      disabled={loading}
    >
      {label}
    </Button>
  );
};
